import { CommonHeader } from "../Common/CommonHeader";

export default function EditorialBoard() {
  return (
    <>
      <CommonHeader title="Editorial Board" />
    </>
  );
}
